// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__Vo7Nu","logOutBtn":"LogoutButton_logOutBtn__V6pHg"};